import './banner.css';

const Banner = () => {
    return(
        <header className='banner-container'>
            <div className='banner-text'>
                <p className='banner-p'>Francielly Silva</p>
                <div>
                    <h1 className='destac'>DEVELOPER FRONT</h1>
                    <h1 className='destac-p'>PORTIFOLIO</h1>
                </div>
            </div>
        </header>
    )
}

export default Banner